import React from 'react'
import { OurAwardsWrapper } from '../styles/OurAwards.styled'
import AwardsDesktop from './AwardsDesktop'
import AwardsMobile from './AwardsMobile'

export default function Awards({ data, id, dir }) {

  return (
    <OurAwardsWrapper id={id}>
        <AwardsDesktop data={data} dir={dir}/>
        <AwardsMobile data={data} dir={dir}/>
    </OurAwardsWrapper>
  )
}
